module.exports = __webpack_public_path__ + "static/img/logo.f2e1e741.png";